export const Store = {
  theme: typeof window !== "undefined" && window.localStorage.getItem("theme"),
}
